'use client';

import StickyBox from 'react-sticky-box';

const PageSideBar = ({ children }) => {
  return <StickyBox>{children}</StickyBox>;
};

export default PageSideBar;
